/**
 * Formata a diferença entre duas datas no formato 'xx anos, xx meses'
 * @param {Date} dataInicial Data inicial para cálculo da idade
 * @param {Date} dataFinal Data final para cálculo da idade
 * @returns {String} Diferença entre as duas datas formatado como texto
 */
function formatarIdade(dataInicial, dataFinal) {
    //Somente calcula se a data final for maior que a inicial
    if (dataFinal <= dataInicial)
        return '';

    let anos = dataFinal.getUTCFullYear() - dataInicial.getUTCFullYear();
    let meses = dataFinal.getUTCMonth() - dataInicial.getUTCMonth();
    const dias = dataFinal.getUTCDate() - dataInicial.getUTCDate();
    //Considera apenas o mês fechado
    if (dias < 0)
        meses--;
    //Considera apenas o ano fechado
    if (meses < 0) {
        anos--;
        meses += 12;
    }

    //Formata a descrição dos anos
    let result = '';
    if (anos) {
        result = `${anos} ano${anos > 1 ? 's' : '' }`;
    }

    //Formata a descrição dos meses
    if (meses) {
        if (result)
            result += ', ';
        result += `${meses} ${meses > 1 ? 'meses' : 'mês' }`;
    }

    if (!meses && !anos) {
        result += `${dias} ${dias > 1 ? 'dias' : 'dia' }`;
    }
    
    return result;
}

export default formatarIdade;